import React, { useState, useEffect } from "react";

import {
  View,
  Text,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
  Alert,
  Switch,
  Modal,
  CheckBox,
  Linking

} from "react-native";
import { Feather, FontAwesome, MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from "@react-native-async-storage/async-storage";

import ScreenLoader from '../../components/ScreenLoader'
import Logo from "../../../assets/logotipo-branco.png"
import styles from "./styles";
import api from "../../services/api";

export default function Login({ navigation }) {
  
  const version = 'v11 08/04/2022';
  
  const [isLoading, setIsLoading] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  const [modalContent, setModalContent] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const [keepLogged, setKeepLogged] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checkboxIsSelected, setCheckboxIsSelected] = useState(true);
  const [useLoginPin, setUseLoginPin] = useState(false);
  useEffect(() => {
    if (window.location.hostname === "localhost") {
      setEmail("tecnologia@klupp.com.br")
      setPassword("123456")
    }
  }, []);

  useEffect(() => {
    checkLogin();
  }, []);

  const checkLogin = async () => {
    let keep = await AsyncStorage.getItem("keep_logged");
    setKeepLogged(keep);
    if(keep && keep === 'true') {
      let emailStorage = await AsyncStorage.getItem("keep_logged_email");
      let pwdStorage = await AsyncStorage.getItem("keep_logged_password");
      setEmail(emailStorage);
      setPassword(pwdStorage);
    }
  }

  const handleLogin = async () => {
    if (!email) {
      alert("Preencha seu e-mail.");
      return false;
    }
    if (!password) {
      alert("Preencha sua senha.");
      return false;
    }
    if (!checkboxIsSelected) {
      alert("Você deve aceitar os termos de uso e privacidade.");
      return false;
    }

    setIsLoading(true);

    const data = { email, password, version};
    api.post("/auth/login", data).then(async (res) => {
      console.log(res)
      await AsyncStorage.setItem("JWT_TOKEN", res.data.access_token);
      
      if(keepLogged) {
        await AsyncStorage.setItem("keep_logged", 'true');
        await AsyncStorage.setItem("keep_logged_email", email);
        await AsyncStorage.setItem("keep_logged_password", password);
      }else{
        await AsyncStorage.removeItem("keep_logged");
      }

      setEmail('');
      setPassword('');
      
      setIsLoading(false);
      navigation.navigate("Tabs");
    }).catch((err) => {
      if (err.response?.status === 401 && err.response?.data?.error && err.response?.data?.error !== 'Unauthorized') {
        alert(err.response.data.error);
        setIsLoading(false);
        return false;
      }
      if (err.request.status === 401) {
        alert("E-mail ou senha incorretos. \n Verifique e tente novamente.")
        setIsLoading(false);
        return false;
      }
      console.log(err.request)
      alert("Houve um erro, tente novamente mais tarde.")
      setIsLoading(false);
    });
  }
  function forgotPassword() {
    const sendForgotPasswordEmail = () => {
      setSpinnerLoading(true);
      api
        .post("auth/reset-password", { email })
        .then((response) => {
          setSpinnerLoading(false);
          alert("Verifique o seu e-mail, o link para o cadastro de uma nova senha foi enviado com sucesso!")
        })
        .catch(({ response }) => {
          setSpinnerLoading(false);
          if (response.status === 404) {
            const { data } = response;
            alert(data.message);
          } else {
            alert("Aconteceu um erro inesperado, por favor, tente mais tarde");
          }
        })
        .finally(() => setSpinnerLoading(false));
    }
    if (!email) {
      alert(
        "Preencha o campo de e-mail para recuperar sua senha."
      );
      setSpinnerLoading(false);
      return false;
    } else {
      if (confirm(`Recuperação de senha\nUm e-mail com um link de recuperação de senha será enviado para ${email}.`)) {
        sendForgotPasswordEmail()
      } else {
        return
      }
    }
  }
  function handleModalTerms() {
    Linking.canOpenURL('https://api.gpxexchange.com.br/termos-privacidade').then(supported => {
      if (supported) {
        Linking.openURL('https://api.gpxexchange.com.br/termos-privacidade');
      } else {
        console.log('url blocked');
      }
    });

    // setModalVisible(true)
    // setModalContent(<Terms
    //   handleCloseModal={() => setModalVisible((visible) => !visible)}
    // />)
  }
  const [hidePassword, setHidePassword] = useState(true);
  const handleShowPassword = () => {
    setHidePassword(!hidePassword);
  }
  return (
    <View style={styles.container}>
      <LinearGradient
        start={{ x: -1, y: 0 }}
        end={{ x: 1.3, y: 0 }}
        colors={["#16576E", "#199991"]}
        style={styles.background}
      >
        <View style={styles.logo}>
          <Image style={{ width: 230, height: 133, marginTop: "10%" }} source={Logo} />
        </View>

        <View style={styles.actionContainer}>
          <View style={styles.loginForm}>
            <View style={styles.passwordContainer}>
              <TextInput
                placeholder="E-mail"
                value={email}
                onChangeText={setEmail}
                style={styles.input}
              />
            </View>
            <View style={styles.passwordContainer}>
              <TextInput
                placeholder="Senha"
                importantForAutofill="no"
                value={password}
                secureTextEntry={hidePassword}
                onChangeText={value => setPassword(value.replace(/[^0-9]/g, ''))}
                style={styles.input}
              />
              <TouchableOpacity style={styles.eyeButton} onPress={handleShowPassword}>
                {hidePassword ? <Feather name="eye" size={18} color="#222" />
                  : <Feather name="eye-off" size={18} color="#222" />}
              </TouchableOpacity>
            </View>
            
            <View style={{marginTop: 5}}>
              <Text style={{textAlign: 'center', color: '#DDD', fontSize: 11}}>{version}</Text>
            </View>

            <View style={[styles.keepLogged]}>
              <Switch
                trackColor={{ false: "#767577", true: "#767577" }}
                thumbColor={keepLogged ? "#1FBFB5" : "#f4f3f4"}
                ios_backgroundColor="#3e3e3e"
                onValueChange={setKeepLogged}
                value={keepLogged}
                disabled={isLoading}
              />
              <Text style={{ marginLeft: 10, color: "#FFF" }}>
                Permanecer logado
              </Text>
            </View>
          </View>
          <View style={styles.checkboxContainer}>
            <CheckBox
              value={checkboxIsSelected}
              onValueChange={setCheckboxIsSelected}
              style={styles.checkbox}
            />
            <View style={styles.checkboxLabelContainer}>
              <Text style={styles.checkboxLabel}>Eu aceito os</Text>
            </View>
            <TouchableOpacity
              style={styles.checkboxLabelContainer}
              onPress={() => handleModalTerms()}
            ><Text style={styles.termsLink} >termos de uso e privacidade.</Text></TouchableOpacity>
          </View>
          <TouchableOpacity
            onPress={handleLogin}
            style={styles.actionButton}
          >
            {isLoading ? (
              <ActivityIndicator color="#1FBFB5" size="large" />
            ) : (
              <Text style={styles.actionButtonText}>Entrar</Text>
            )}
          </TouchableOpacity>

          <TouchableOpacity
            onPress={forgotPassword}
            style={styles.forgotPassword}
          >
            <Text style={styles.forgotPasswordText}>Esqueci minha senha</Text>
          </TouchableOpacity>

          <ScreenLoader loading={spinnerLoading} />

          <Modal
            animationType="fade"
            transparent={false}
            visible={modalVisible}
            statusBarTranslucent={true}
            onRequestClose={() => setModalVisible((visible) => !visible)}
          >
            <View style={styles.header}>
              <TouchableOpacity style={styles.closeButton} onPress={() => setModalVisible((visible) => !visible)}><Text>FECHAR</Text>
                <MaterialIcons
                  name="close"
                  size={30}
                  color="black"
                />
              </TouchableOpacity>
            </View>
            {modalContent}
          </Modal>
        </View>
      </LinearGradient>
    </View>
  );
}
